<template>
   <div class="container">
      <div class="header headerImage">
         <img src="/static/gfx/oxs.svg" class="oxsLogo" />
         <h2 style="max-width: 330px;color:#ff6500">תודה על פנייתכם</h2>
      </div>
      <div class="oval"></div>
      <div class="secondTab">
         <span class="topText">
            <p class="blueText">פנייתכם התקבלה, נחזור אליכם בהקדם</p>
         </span>
      </div>
      <div style="display: flex;justify-content: center;margin-top: 50px;">
         <button class="normal" @click="$router.push({ name: 'Main' })">
            חזרה לOXS
         </button>
      </div>
   </div>
</template>

<script>
export default {
   name: 'MainPage',
   data() {
      return {
         windowWidth: 0,
         phoneError: false,
         sendDisabled: false,
         emailError: false,
         nameError: false,
         showError: false,
         info: 'none',
         name: null,
         email: null,
         phone: '',
         required: ['name', 'email', 'phone', 'info'],
         loginEmail: null,
         loginPassword: null,
         showBackToClentTenant: localStorage.manager,
         termsAccepeted: false,
         thankYouPage: false,
      }
   },
   methods: {
      async requestJoin() {
         if (
            this.info == 'none' ||
            this.phoneError ||
            this.emailError ||
            this.nameError ||
            this.sendDisabled
         ) {
            return (this.showError = true)
         } else {
            let object = {
               name: `${this.name} - ${this.info}`,
               email: this.email,
               phone: this.phone,
               sendTo: 'yam@oxs.co.il',
            }
            await this.$http.post('contact', object)
            document.getElementById('submit').value = 'פנייתך התקבלה! תודה'
            document.getElementById('submit').disabled = false
            this.name = ''
            this.email = ''
            this.phone = ''
            this.sendDisabled = true

            let thankYouScript = document.createElement('script')
            thankYouScript.innerHTML = `!function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '285089946226737');
            fbq('track', 'PageView');
          fbq('track', 'CompleteRegistration');`

            let thankYouImage = document.createElement('img')
            thankYouImage.style.display = 'none'
            thankYouImage.src =
               'https://www.facebook.com/tr?id=285089946226737&ev=PageView&noscript=1'
            thankYouImage.setAttribute('height', 1)
            thankYouImage.setAttribute('width', 1)

            let body = document.querySelector('body')
            body.appendChild(thankYouScript)
            body.appendChild(thankYouImage)
            this.thankYouPage = true
            setTimeout(() => {
               this.sendDisabled = false
            }, 10000)
         }
      },
      scrollToBottom() {
         window.scrollTo(0, document.querySelector('.container').scrollHeight)
      },
      login() {
         if (
            !this.loginEmail ||
            this.loginEmail.length === 0 ||
            !this.loginPassword ||
            this.loginPassword.length === 0
         ) {
            alert('יש למלא את הכל השדות בטופס')
            return false
         }
         let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
         if (!reg.test(this.loginEmail)) {
            alert('כתובת המייל אינה תקינה')
            return false
         }
         this.$http
            .post('api/user/login', {
               loginEmail: this.loginEmail,
               loginPassword: this.loginPassword,
               termsAccepeted: this.termsAccepeted,
            })
            .then(res => {
               if (res.data.status === 1 && res.data.data != 0) {
                  localStorage['at'] = res.data.data.token
                  localStorage['u'] = JSON.stringify(res.data.data.user)
                  localStorage['allowedPaths'] = JSON.stringify(
                     res.data.data.user.allowedPaths
                  )
                  location = '/main/stats'
               } else if (res.data.data === 0) {
                  alert('פעולה חד פעמית - נא לאשר את תנאי השימוש')
               }
            })
            .catch(e => {
               if (e.body.data === 'NOT FOUND') {
                  alert('שם משתמש או סיסמא אינם נכונים')
               }
               if (e.body.data === 'NOT ACTIVE') {
                  alert('משתמש לא פעיל')
               }
               if (e.body.data === '0') {
                  alert('פעולה חד פעמית - נא לאשר את תנאי השימוש')
               }
            })
      },
      resetPassword() {
         if (this.loginEmail.length === 0) {
            alert('אנא הזן כתובת מייל לקבלת הודעת איפוס סיסמא')
         } else {
            this.$http
               .get(`api/user/resetPassword/${this.loginEmail}`)
               .then(res => {
                  if (res.data.data === 'no user') {
                     alert('כתובת המייל שהוזנה לא קיימת במערכת.')
                  } else {
                     alert('הודעת איפוס סיסמא נשלחה למייל שהוזן.')
                  }
               })
         }
      },
      loginWindow() {
         if ($('#dark').css('display') == 'none') {
            $('#dark').fadeIn(200)
            $('#login-win').show()
            setTimeout(() => {
               $('#login-win').addClass('loginOn')
            }, 10)
         } else {
            $('#dark').fadeOut(200)
            $('#login-win').removeClass('loginOn')
            setTimeout(() => {
               $('#login-win').show()
            }, 210)
         }
      },
   },
   computed: {
      isSendDisabled() {
         return this.sendDisabled
      },
      getWidth() {
         return this.windowWidth / 7
      },
   },
   created() {
      this.windowWidth = window.innerWidth
      window.addEventListener('resize', () => {
         this.windowWidth = window.innerWidth
      })
   },
   watch: {
      phone() {
         var re = /^\d+$/
         this.phoneError = !re.test(this.phone)
      },
      email() {
         var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
         this.emailError = !re.test(this.email)
      },
      name() {
         this.nameError = !this.name.length > 0
      },
   },
}
</script>
<style lang="less" scoped>
@background: #f4f4f4;
@blue-dark: #336699;
@grey-light: #d6d6d6;
@blue: #336699;
@grey: @grey-medium;
@orange: #ff6500;
@red: #cc3300;
@grey-dark: #45434b;
@purple: #336699;
@grey-medium: #ccc;
@white: #ffffff;
@hover: #eeeeee;
@grey-border: #ccc;
@header: @blue;
@boxShadow: 0;
@border: solid 1px @grey-border;
@bold: 0.3px 0 0 @grey-dark;
@borderBottom: 1px solid rgba(69, 67, 75, 0.21);
@borderBottomHighlight: 1px solid rgba(69, 67, 75, 0.31);
@titleColor: @blue-dark;
@titleBorder: 1px solid @blue;

h1 {
   font-size: 30px;
   font-weight: 600;
   text-align: center;
}

h2 {
   font-size: 25px;
   text-align: center;
}

.container {
   padding: 0 !important;
   margin: 0 !important;
   position: absolute;
   top: 0;
   width: 100%;
   overflow: hidden;
   background: @background;
}

.blue {
   .buttonStyle(@blue, @white, transparent);
}

.normal {
   .buttonStyle(@orange, @white, transparent);
}

.white {
   .buttonStyle(@white, @orange, @orange);
}

.header {
   .flex-center;
   justify-content: center;
   height: 490px;
}

.oval {
   background: @background;
   position: absolute;
   position: absolute;
   overflow: hidden;
   height: 159px;
   right: 0;
   left: 0;
   top: 422px;
   border-radius: 53%;
   margin: auto;
}

.headerImage {
   background-image: url('../../static/gfx/mainPage.jpg');
   background-repeat: no-repeat;
   background-size: cover;
   background-position: bottom;
}

.headerBtns {
   position: absolute;
   right: 50px;
   top: 50px;
   button {
      margin-left: 25px;
   }
   display: flex;
}

.phone-num {
   position: absolute;
   left: 50px;
   top: 50px;
   img {
      position: absolute;
      width: 26px;
      top: 5px;
      left: 20px;
   }
}

.buttonStyle(@color, @text, @border ) {
   padding: 15px 10px;
   min-width: max-content;
   min-width: 200px;
   text-align: center;
   display: block;
   z-index: 5;
   color: @text;
   background: @color !important;
   border-radius: 25px;
   text-align: center;
   border: 1px solid @border;
   outline: 0;
   font-size: 17px;
   line-height: 7px;
   cursor: pointer;
   transition: all 0.3s ease-in;
   box-shadow: 1px 1px 3px 0 rgba(15, 15, 15, 0.15),
      -1px -1px 3px 0 rgba(255, 255, 255, 0.15);
   text-shadow: darken(@color, 2%);

   &:hover {
      background: lighten(@color, 12%) !important;
   }

   &:active {
      box-shadow: inset 1px 1px 3px 0 rgba(15, 15, 15, 0.15),
         inset -1px -1px 3px 0 rgba(255, 255, 255, 0.15);
      background: darken(@color, 10%) !important;
   }
}

.oxsLogo {
   width: 311px;
   height: 126px;
}

.secondTab {
   .flex-center;
   position: relative;

   justify-content: center;
}

.blueText {
   margin: 0;
   font-size: 25px;
   color: @blue;
   letter-spacing: -0.02px;
}

.topText {
   text-align: center;
}

ul {
   list-style: none;
}

.cards {
   margin-top: 90px;
   h2 {
      font-size: 25px;
   }
}

.cardsContainer {
   display: flex;
   flex-wrap: wrap;
   justify-content: center;
   .card {
      h3 {
         font-weight: 600;
         font-size: 20px;
      }
      .flex-center;
      justify-content: center;
      margin: 25px;
      p {
         text-align: right;
         font-size: 20px;
         width: 60%;
      }
      width: 33vw;
      height: 200px;
      border-radius: 20px;
      box-shadow: 4px 4px 20px 0 rgba(69, 67, 75, 0.33);
      background-color: #ffffff;
   }
}

.thirdTab {
   position: relative;
   background: @blue;
   height: 270px;
   img {
      width: 290px;
      position: relative;
      margin-top: -8px;
      margin-right: -71px;
   }
   span {
      position: absolute;
      margin: auto;
      margin-top: 25px;
      left: 0;
      right: 0;
      width: 75%;
      text-align: center;
   }
   p {
      font-size: 25px;
      margin: 0;
   }
   h2 {
      margin-bottom: 35px;
   }
   p,
   h2 {
      font-size: 25px;
      text-align: center;
      color: @white;
   }
}

.fourthTab {
   margin-top: 100px;
   background-image: url('../../static/gfx/greyBack.svg');
   background-repeat: no-repeat;
   background-size: cover;
   display: flex;
   height: 364px;
   h3 {
      font-weight: 600;
      font-size: 32px;
      color: @blue;
      letter-spacing: -0.02px;
      margin: 0;
      margin-right: 25vw;
   }
   p {
      margin: 0;
      font-size: 25px;
      margin-right: 25vw;
   }
   .imgContainer {
      position: relative;
      img {
         height: 380px;
         margin-left: 15vw;
      }
   }
}

.flex-center {
   display: flex;
   flex-direction: column;
   align-items: center;
}

@keyframes scroll {
   0% {
      transform: translateX(0);
   }
   100% {
      transform: translateX(calc(-250px * 11));
   }
}

.connect {
   background: @white;
   display: flex;
   margin-top: 100px;
   height: 440px;
   .form {
      select,
      input {
         margin: 10px 0;
         padding: 0 10px;
         height: 40px;
         border-radius: 25px !important;
         width: 313px;
         border: 1px solid @blue;
         outline: 0;
         font-size: 17px;
         line-height: 7px;
      }
      margin-top: 100px;
      margin-right: 20vw;
      display: flex;
      flex-direction: column;
   }
   .imgContainer {
      position: relative;
      top: -13px;
      img {
         opacity: 0.6;
         margin-right: 30vw;
         height: 465px;
      }
   }
}

.footer {
   margin-top: 100px;
   position: relative;
   height: 180px;
   bottom: 0;
   background: #45434b;
   .nav {
      display: flex;
      align-items: center;
      margin-right: 50px;
      z-index: 10;
      li {
         margin-top: 25px;
         margin-left: 15px;
         font-size: 16px;
         letter-spacing: -0.01px;
         color: @white;
      }
   }
   .rights {
      color: @white;
      text-align: center;
      bottom: 25px;
      position: absolute;
      margin: auto;
      left: 0;
      right: 0;
   }
   .rights::after {
      content: '\00a9';
   }
   .contact {
      direction: ltr;
      display: flex;
      p {
         width: 120px;
         text-align: start;
         margin: 0;
         margin-top: 25px;
         margin-left: 35px;
         font-size: 18px;
         letter-spacing: -0.01px;
         color: @white;
      }
   }
}

a {
   text-decoration: none;
   color: @white;
   &:hover {
      color: #ccc;
   }
}

.arrows {
   position: absolute;
   img {
      position: relative;
      margin-top: 28px;
   }
}

.iframeContainer {
   width: 50%;
   margin: 10px auto 40px auto;
}

#error {
   color: @red;
   font-weight: bolder;
   display: none;
}

.redBorder {
   border: 1px solid @red !important;
}

body {
   margin: 0 !important;
}

/deep/ .VueCarousel {
   /deep/ .VueCarousel-dot {
      :first-child {
         position: absolute;
         left: 0;
      }
      background-color: @grey !important;
   }
   /deep/ .VueCarousel-dot--active {
      background-color: black !important;
   }
}

// .container {
// }
// * {
//   direction: ltr !important;
// }
.moveRight {
   transform: translate(-718.8px, 0px);
   transition: transform 0.5s ease 0s;
   flex-basis: 239.6px;
   visibility: visible;
   height: auto;
}

.moveLeft {
   transform: translate(0px, 0px);
   transition: transform 0.5s ease 0s;
   flex-basis: 239.6px;
   visibility: visible;
   height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/ThankYou.vue